/** Phân luồng eSIM trong Vuex `orderDetail.esimOrderFlow` và `detailPaymentInfo.flowType`. */
export const ESIM_ORDER_FLOW = {
  BUY: "BUY_ESIM",
  CHANGE: "CHANGE_TO_ESIM",
};
